import { UploadedFile } from "@/components/FileUploadZone";
import api from "./axios-service";

export type ShareSettings = {
  expiresAt: Date;
  password: string;
  files: UploadedFile[];
};

export type ShareResponse = {
  id: string;
  slug: string;
  expiresAt: Date;
  createdAt: Date;
};

export async function generateShare(data: ShareSettings) {
  const { data: response } = await api.post<ShareResponse>("/share", data);
  return response;
}

export async function getRecentShares() {
  const { data: response } = await api.get<ShareResponse[]>("/share");
  return response;
}

export async function getShare(shareId: string) {
  const { data } = await api.get(`/share/${shareId}`);
  return data;
}


export async function getShareFiles(shareId: string, password: string) {
  const { data } = await api.post(`/share/${shareId}/files`, {
    password,
  });
  return data;
}
